const PIPELINE_STATUSES = {
  NotDeployed: 'Not Deployed',
  StagedForDeploy: 'Staged for Deploy',
  Deployed: 'Deployed',
  Error: 'Error',
  Unknown: 'Unknown',
};

export default PIPELINE_STATUSES;
